import { userDataApi } from "../Common/api";
import { baseUrl } from "../Common/BaseUrl";
import * as crud from "./OpsServies";

const userData=(sendData,token)=>{
    let data = crud.post(userDataApi,sendData,token)
    return data
}

export{userData}